









































































































import {
	defineComponent,
	PropType,
	computed,
	ref,
	watch,
	Ref,
} from '@vue/composition-api';
import { sub } from 'date-fns';
import deepEqual from 'deep-equal';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import EventBannerDataTable from '@front-app/modules/eventData/components/EventBannerDataTable.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import TrForm from '@front-app/components/form/Form.vue';
import YearMonthDayInput from '@front-app/components/inputs/YearMonthDayInput.vue';
import { BannerAction, UserAction } from '@front-app/services/ActionApi/UserActionRequestModel';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { EventBannerReportData } from '@front-app/services/EventsApi/EventDataModel';
import { fetchEventBannerData } from '@front-app/services/EventsApi/EventDataApi';
import { Size, Spacing } from '@front-app/components/constants';
import { syncedRef } from '@front-app/util/reactivity';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { REPORT_TYPE } from '@front-app/services/CommunityApi/CommunityReportsApi';

const ACTION_LABELS: Record<BannerAction, string> = {
	[UserAction.BANNER_VIEW]: 'Banner Views',
	[UserAction.BANNER_CLICK]: 'Banner Clicks',
};

const ACTION_OPTIONS = [
	UserAction.BANNER_VIEW,
	UserAction.BANNER_CLICK,
];

export default defineComponent({
	components: {
		CtaButton,
		EventBannerDataTable,
		ErrorCard,
		FormInput,
		FormLabel,
		FormSection,
		HelpTooltipBlock,
		LoaderState,
		SelectBox,
		TrForm,
		YearMonthDayInput,
	},
	props: {
		eventId: {
			type: String,
			required: false,
			default: '',
		},
		fromDate: {
			type: Date,
			required: false,
			default: () => sub(new Date(), { days: 30 }),
		},
		toDate: {
			type: Date,
			required: false,
			default: () => new Date(),
		},
		action: {
			type: String as PropType<BannerAction>,
			required: false,
			default: UserAction.BANNER_VIEW,
		},
	},
	setup(props, ctx) {
		const eventIdLocal = syncedRef(() => props.eventId).ref;
		const actionLocal = syncedRef(() => props.action).ref;
		const fromDateLocal = syncedRef(() => props.fromDate).ref;
		const toDateLocal = syncedRef(() => props.toDate).ref;

		const actionOptions = computed(() => ACTION_OPTIONS.map((key) => ({
			key,
			label: ctx.root.$t(ACTION_LABELS[key]) as string,
		})));

		const navigate = () => {
			ctx.root.$router.push({
				params: {
					eventId: eventIdLocal.value,
				},
				query: {
					action: actionLocal.value,
					fromDate: fromDateLocal.value.toISOString(),
					toDate: toDateLocal.value.toISOString(),
				},
			});
		};

		const reportData: Ref<EventBannerReportData[]> = ref([]);
		const dataRequestStatus = useAsyncStatus();
		const fetchData = async (eventId: string) => {
			if (!eventId) {
				return;
			}
			reportData.value = await dataRequestStatus.track(fetchEventBannerData(eventId, {
				action: actionLocal.value,
				fromDate: fromDateLocal.value,
				toDate: toDateLocal.value,
			}));
		};
		const watchFetcherData = (): [string, Date, Date, UserAction] => [props.eventId, props.fromDate, props.toDate, props.action];
		watch(watchFetcherData, (curr, prev) => {
			if (deepEqual(curr, prev)) {
				return;
			}
			fetchData(curr[0]);
		}, { immediate: true });

		return {
			REPORT_TYPE,
			eventIdLocal,
			actionLocal,
			actionOptions,
			ACTION_LABELS,
			fromDateLocal,
			toDateLocal,
			navigate,
			reportData,
			dataRequestStatus,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
